import * as React from 'react';
import PropTypes from 'prop-types';
import { cn } from '../../lib/utils';

export const Textarea = React.forwardRef(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn('flex min-h-[92px] w-full rounded-lg border border-slate-200/80 bg-white px-3 py-2 text-sm text-slate-950 shadow-sm outline-none placeholder:text-slate-400 focus:ring-2 focus:ring-primary/30 disabled:cursor-not-allowed disabled:opacity-50', className)}
    {...props}
  />
));
Textarea.displayName = 'Textarea';
Textarea.propTypes = { className: PropTypes.string };
